import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const VADundee = ({featuredProjectsList}) => {
  const project = getProject('va-dundee');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          component={{
            image:
              '//images.yourmajesty.co/20180626084850/180620_VandA_Case_WebHeader.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="new-territory">New territory</h2>
          <p>
            V&amp;A Dundee is the first ever dedicated design museum in
            Scotland. Established in close partnership with the Victoria and
            Albert Museum in London, V&amp;A Dundee is part of the wider V&amp;A
            family with design as a common thread from London to Dundee to
            Shenzhen in China.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="constructing-a-creative-hub">Constructing a creative hub</h2>
          <p>
            The website is a vital piece in the opening of the brand new V&amp;A
            Dundee, an all-in-one design museum, cultural venture and ‘must-see’
            visitor attraction that positions the city of Dundee as a new
            creative hotspot and tourist destination.
          </p>
          <p>
            V&amp;A Dundee is a part of the greater V&amp;A family, so our key
            challenge was to provide audiences with a user experience that is
            consistent with other V&amp;A museum sites but still conveys the
            Dundee branch’s distinctive identity.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="designing-for-a-design-museum">
            Designing for a design museum
          </h2>
          <p>
            We began by sketching out a set of design principles to act as the
            foundation and polestar for all of our design decisions. These
            principles helped to paint the picture of our design landscape early
            on in the process.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190521135612/Artboard-2.png',
            calculateRatio: '1920,1490'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Inspired by the modern architecture of the Dundee museum, we
            envisioned a website that reflects the building’s unique
            construction as a connection between the city and its waterfront.
          </p>
          <p>
            During the early design stages, we used eye-tracking technology in
            user tests to validate if the designed elements received their
            intended attention to logically express the website’s narrative.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190521135728/Artboard-1.png'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="building-on-a-legacy">Building on a legacy</h2>
          <p>
            Our development team was able to jumpstart the work by leveraging
            the existing V&amp;A codebase and shaping it into a modern, light
            and crisp platform, one that is worthy of V&amp;A Dundee’s great
            unveiling.
          </p>
          <p>
            In close collaboration with the V&amp;A digital media team in London
            and the V&amp;A Dundee team, we ensured a consistent user journey by
            applying updated identity guidelines, substituting modules and
            incorporating several third-party integrations, all while holding
            design, performance, accessibility and individuality in high regard.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190521135918/Artboard-3.png',
            calculateRatio: '1920,3604'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="design-futures">Design futures</h2>
          <p>
            In summary, we're proud to have an ongoing collaboration with
            V&amp;A Dundee, and look forward to supporting the organization’s
            mission of attracting new businesses, investors, professionals and
            visitors to the Dundee area.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="collaborators">Collaborators</h2>
          <p>
            Jankees van Woezik
            <br />
            Yvonne Lu
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Collaborative Working Sessions',
                  'Content Strategy',
                  'Interviews & User Testing',
                  'Product Strategy',
                  'Prototyping & Validation',
                  'Research',
                  'Roadmapping',
                  'Technical Strategy',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Booking Engine',
                  'Front-end Development',
                  'Localization',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'A/B Testing',
                  'Analytics & Insights',
                  'Integration Support',
                  'Launch',
                  'Optimization',
                  'Quality Assurance'
                ]
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://www.vam.ac.uk/dundee',
            title: 'Visit website'
          }}
        />
        
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default VADundee;
